import React, {useContext, useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {Button, Col, Row} from "reactstrap";
import {t} from "i18next";
import {useForm} from "react-hook-form";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import {CURRENCIES_KEYS} from 'sv-common/constants/currencies';
import {TableCard} from "../../../../generic/cards";
import {ElementWithPermissions} from "../../../../common/formElements";
import EditModalChildren from '../../EditModalChildren';
import {handleInputChange} from "../../../../../lib/utils/handleInputChange";
import getCountryValue from '../../../../../lib/utils/getCountryValue';
import {IsFormValueState} from "../../../../directories/legalEntities";
import {showDangerToast, showSuccessToast} from "../../../../generic/modals/EditModal";
import {useDefaultEndpoints} from "../../../../../lib/api/useDefaultEndpoints";
import {withBreadcrumbs} from "../../../../common/hoc/Breadcrumbs"

dayjs.extend(weekday)

const initializeGroup = (groupToCopy, type) => {
    return groupToCopy
        ? {...groupToCopy}
        : {
            price_currency: getCountryValue({ ru: CURRENCIES_KEYS.RUB, en: CURRENCIES_KEYS.AED }),
            category: type === 'lecture' ? undefined : 'school',
            place: t('school.theory.groupsList.moscow'),
            total_sits: 12,
            start_time: '19:30:00.000',
            price_value: 31500,
            type,
            start_date: dayjs().toDate(),
            timezone: "+0300",
            are_promocodes_active: true,
            lessons_per_day: 1
        };
};

const createOrUpdate = (v, isFormValue, entity, editEntry, createEntry, transitionOnNewUrl) => {
    const value = isFormValue ? { ...entity, ...v } : entity

    if (entity.id) editEntry(entity.id, value)
        .then((res) => {
            showSuccessToast(t('common.success'));
            transitionOnNewUrl()
        })
        .catch(showDangerToast)
    else createEntry(value).then((res) => {
        showSuccessToast(t('common.success'));
        transitionOnNewUrl()
    })
        .catch(showDangerToast);
};

const Group = withBreadcrumbs(({entityName = 'groups', isFormData = false, isUploadOnlyFile = false}) => {
    const [entity, setEntity] = useState({});
    const [groupToCopy, setGroupToCopy] = useState(undefined);
    const isFormValue = useContext(IsFormValueState);
    const {createEntry, editEntry} = useDefaultEndpoints(entityName, isFormData, isUploadOnlyFile);
    const {handleSubmit, control, errors, register, reset} = useForm({reValidateMode: 'onBlur',});
    let history = useHistory();
    const location = useLocation();

    const type = location.pathname.includes('lecture') ? 'lecture' : 'theory';

    const createNewUrl =  (type) => `/school/${type === 'lecture' ? 'lectures' : type}`

    const transitionOnNewUrl = () => {
        history.replace(createNewUrl(type));
    }

    const handleInput = (e, setEntity) => {
        const {name, value} = handleInputChange(e)
        setEntity(entity => ({...entity, [name]: value}))
        return {name, value};
    }

    const onSubmit = handleSubmit((v) => {
        createOrUpdate(v, isFormValue, entity, editEntry, createEntry, transitionOnNewUrl);
    })

    useEffect(() => {
        const initialEntry = initializeGroup(groupToCopy, type);
        setEntity(initialEntry);
        isFormValue && reset(initialEntry);
    }, [groupToCopy, type, reset, isFormValue])

    return (<TableCard>
                <Row className={'mb-5 justify-content-between align-items-center'}>
                    <Col className={'col-sm-auto col-12 flex-grow-1 col mb-3 mb-sm-0'}>
                        <h4 className={'display-4'}>{t('school.theory.groupsList.newGroupTheory')}</h4>
                    </Col>
                    <Col className={'col-auto'}>
                        <ElementWithPermissions>
                            <Button className={'btn-rounded'} color={'success'} size={'sm'} onClick={onSubmit}>
                                {t('adventures.edit.save')}
                            </Button>
                        </ElementWithPermissions>
                    </Col>
                    <Col className={'col-auto'}>
                        <Button className={'btn-rounded ml-1'} color={'secondary'} size={'sm'} onClick={transitionOnNewUrl}>
                            {t('adventures.edit.cancel')}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        {EditModalChildren({entity, setEntity, control, errors, handleInput, register})}
                    </Col>
                </Row>

                <Row className={'mb-5 justify-content-end align-items-center'}>
                    <Col className={'col-auto'}>
                        <ElementWithPermissions>
                            <Button className={'btn-rounded'} color={'success'} size={'sm'} onClick={onSubmit}>
                                {t('adventures.edit.save')}
                            </Button>
                        </ElementWithPermissions>
                    </Col>
                    <Col className={'col-auto'}>
                        <Button className={'btn-rounded ml-1'} color={'secondary'} size={'sm'} onClick={transitionOnNewUrl}>
                            {t('adventures.edit.cancel')}
                        </Button>
                    </Col>
                </Row>
            </TableCard>
    )
})

export default Group;